import React from 'react';

import { Gutter } from '../../layout/Gutter/Gutter';
import { Card } from '../../layout/Card/Card';

import { ClientEngagementNoTalentCardSection } from './ClientEngagementNoTalentCardSection';

export const ClientEngagementNoTalentCardForPdf = () => (
  <Gutter horizontal="24px" bottom="32px">
    <Card name="non-self-service-no-profile">
      <ClientEngagementNoTalentCardSection />
    </Card>
  </Gutter>
);
